import React from "react";

const IconChevron = ({ isOpen, width = 16, height = 16, className = "" }) => (
  <svg 
    width={width}
    height={height}
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    className={className}
    style={{ 
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', 
      transition: 'transform 0.2s ease' 
    }}
  >
    <polyline points="6,9 12,15 18,9" />
  </svg>
);

export default IconChevron; 